import { useJune } from "../assets/custom-hooks/useJune";
import { createContext, useContext } from "react";

const JUNE_KEY = process.env.REACT_APP_JUNE_KEY;

export const JuneContext = createContext(null);

export const JuneProvider = ({ children }) => {
  const analytics = useJune(JUNE_KEY);

  return <JuneContext.Provider value={analytics}>{children}</JuneContext.Provider>;
}

export const useJuneProvider = () => {
  return useContext(JuneContext);
} 